import { z } from 'zod';
import type { NpsRole } from '@/shared/types/nps';

const npsRoleEnum = z.enum(['admin', 'org', 'user'] satisfies [NpsRole, NpsRole, NpsRole]);

export const npsUserCreateSchema = z.object({
  name: z.string().min(1, 'Informe o nome'),
  last_name: z.string().min(1, 'Informe o sobrenome'),
  email: z.string().email('E-mail inválido'),
  tax_identifier: z.string().min(11, 'Informe CPF ou CNPJ válido'),
  password: z.string().min(6, 'Senha deve ter ao menos 6 caracteres'),
  role: npsRoleEnum,
  legacy_user_id: z.string().optional(),
});

export const npsUserUpdateSchema = npsUserCreateSchema
  .omit({ password: true, email: true })
  .partial()
  .extend({
    name: z.string().min(1).optional(),
    last_name: z.string().min(1).optional(),
    tax_identifier: z.string().min(11).optional(),
    legacy_user_id: z.string().optional(),
    role: npsRoleEnum.optional(),
  });

export type NpsUserCreateValues = z.infer<typeof npsUserCreateSchema>;
export type NpsUserUpdateValues = z.infer<typeof npsUserUpdateSchema>;

export const npsProfileInfoSchema = z.object({
  name: z.string().min(1),
  last_name: z.string().min(1),
  tax_identifier: z.string().min(11),
});

export const npsPreferencesSchema = z.object({
  primary_color: z.string().min(1),
  secondary_color: z.string().min(1),
});
